/** Default values for development environment */
const DEFAULT_BUILD_INFO = {
    env: 'development',
    commitSha: 'unknown',
    buildTime: new Date().toISOString(),
};
/**
 * Get current Build Metadata
 * - Worker: reads from environment variables (ENVIRONMENT, COMMIT_SHA, BUILD_TIME)
 * - Web: fetches from /version API at runtime
 *
 * @param envVars - Optional environment variables object (for Worker runtime)
 * @returns BuildInfo object with env, commitSha, and buildTime
 */
export function getBuildInfo(envVars) {
    // If envVars provided (Worker context), read from them
    if (envVars) {
        return {
            env: envVars['ENVIRONMENT'] || DEFAULT_BUILD_INFO.env,
            commitSha: envVars['COMMIT_SHA'] || DEFAULT_BUILD_INFO.commitSha,
            buildTime: envVars['BUILD_TIME'] || DEFAULT_BUILD_INFO.buildTime,
        };
    }
    // Default: return development values
    // Web context should fetch from /version API instead
    return { ...DEFAULT_BUILD_INFO };
}
/**
 * Create BuildInfo from Worker environment bindings
 * Convenience function for Cloudflare Workers
 */
export function createBuildInfoFromEnv(env) {
    return {
        env: env.ENVIRONMENT || DEFAULT_BUILD_INFO.env,
        commitSha: env.COMMIT_SHA || DEFAULT_BUILD_INFO.commitSha,
        buildTime: env.BUILD_TIME || DEFAULT_BUILD_INFO.buildTime,
    };
}
//# sourceMappingURL=buildInfo.js.map